// Declination of numbers for russian language
// expamle: russianDeclinationOfNumber(5, ['секунда', 'секунды', 'секунд'])

export const russianDeclinationOfNumber = (
  number: number,
  titlesCustom: [string, string, string],
): string => {
  const cases = [2, 0, 1, 1, 1, 2]
  const caseIndex =
    (number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]) ?? 0

  return titlesCustom[caseIndex as 0 | 1 | 2] ?? titlesCustom[0]
}
